export const LOGO =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/logo/waazes-no-bg.png";

export const HERO_IMAGE =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/hero-image.jpg";

export const DOT_DECOR =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/dots-square.svg";

export const CAREER_IMAGE =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/career_photo.jpg";

export const ABOUT_US_IMAGE =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/home-image-2.jpg";

export const SUCCESS_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/icons/success-icon.svg";

export const TWITTER_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/twitter.svg";
export const LINKEDIN_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/linkedin.svg";
export const FACEBOOK_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/facebook.svg";
export const INSTAGRAM_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/instagram.svg";
export const LOCATION_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/location-on.svg";
export const EMAIL_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/email.svg";
export const PHONE_ICON =
  "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/Footer-icons/local-phone.svg";

export const COMPANIES = [
  {
    alt: "Siemens Healthineers",
    logo: "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/siemens-healthineers-seeklogo.com.png",
  },
  {
    alt: "Spotify",
    logo: "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/spotify-seeklogo.com.png",
  },
  {
    alt: "Premier League",
    logo: "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/premium-league.png",
  },
  {
    alt: "Vortex",
    logo: "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/vortex.png",
  },
  {
    alt: "Amplitude",
    logo: "https://robor-team.s3.eu-central-1.amazonaws.com/cas-tech/amplitude-seeklogo.com.png",
  },
];

export const SERVICES = [
  {
    heading: "Cybersecurity",
    details:
      "Protect your business with our expert cybersecurity services like advanced threat detection, risk management, and 24/7 protection.",
  },
  {
    heading: "Enterprise Management",
    details:
      "We can assist in strategic enterprise management, management & financial account and business analytics.",
  },
  {
    heading: "Design, Build and Operate Infrastructure",
    details:
      "We can help with demand & requirements planning, operations & maintenance and network design & develoment.",
  },
  {
    heading: "Software Business Application Development",
    details:
      "We can improve your business by providing customized or off-the-shelf software solutions.",
  },
  {
    heading: "Business Automation",
    details:
      "We can provide feasability study for business automation and figure out areas in your business that can be optimized by automation.",
  },
  {
    heading: "Data Warehousing",
    details:
      "We can provide development and implementation of data warehousing using standard products.",
  },
  {
    heading: "Database Related Services",
    details:
      "We can provide design and development of database servers and performance tuning of existing databases like Oracle, MSSQL and MYSQL databases.",
  },
  /*   {
    heading: "Data Storage",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ex ipsum, rhoncus sed sollicitudin eget, cursus ultricies magna.",
  },
  {
    heading: "IT Offshoring",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ex ipsum, rhoncus sed sollicitudin eget, cursus ultricies magna.",
  }, */
];
